import script from "./AppBreadcrumb.vue?vue&type=script&setup=true&lang=js"
export * from "./AppBreadcrumb.vue?vue&type=script&setup=true&lang=js"

import "./AppBreadcrumb.vue?vue&type=style&index=0&id=212bfbd7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-212bfbd7"]])

export default __exports__